import * as ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import '@studio/routes/hub/admin/assets/fonts/poppins/poppins.css'
import '@runtime/app/app.scss'

import { I18nProvider } from '@runtime/core/i18n/i18n'
import { UserProvider } from '@runtime/core/user/userContext'
import { startThemeSync } from '@runtime/core/theme/themeSync'

import App from './app/App'

if (!window.location.pathname.endsWith('/business/presentation')) startThemeSync()

const rootElement = document.getElementById('root')

if (!rootElement) {
  throw new Error('Root element #root not found')
}

const routerBase = import.meta.env.BASE_URL === '/' ? undefined : import.meta.env.BASE_URL

ReactDOM.createRoot(rootElement).render(
  <I18nProvider>
    <UserProvider>
      <BrowserRouter
        basename={routerBase}
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <App />
      </BrowserRouter>
    </UserProvider>
  </I18nProvider>,
)
